module.exports = __webpack_public_path__ + "static/media/team-impulse-hype-preview.620e9953.mp4";